import { Injectable, OnInit } from "@angular/core";
import { Mensagem } from "../_models/mensagem";

@Injectable({ providedIn: 'root' })
export class TratamentoMensagensService implements OnInit {

    private mensagens: Mensagem[];

    constructor() {
        this.mensagens = [];

        this.mensagens[0] = { mensagemEntrada: 'One or more errors occurred. (Lover com CPF 12345678910 já cadastrado)'.replace(/[0-9]/g, ''), mensagemSaida: 'Já existe um cadastro com o CPF informado' };
        this.mensagens[1] = { mensagemEntrada: 'One or more errors occurred. (O campo CPF está inválido)', mensagemSaida: 'CPF inválido' };
        this.mensagens[2] = { mensagemEntrada: 'One or more errors occurred. (Lover com E-mail teste@teste.com já cadastrado)'.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi, ''), mensagemSaida: 'E-mail já cadastrado' };
        this.mensagens[3] = { mensagemEntrada: 'Deve ser maior de 18 anos para se cadastrar em nossa plataforma!', mensagemSaida: 'Apenas pessoas maiores de 18 anos podem participar do programa!' };
    }

    ngOnInit(): void {
    }

    tratarMensagem(mensagem: string): string {
        try {
            if (this.mensagens.filter(m => m.mensagemEntrada === mensagem.replace(/[0-9]/g, '')).length > 0)
                return this.mensagens.filter(m => m.mensagemEntrada === mensagem.replace(/[0-9]/g, ''))[0].mensagemSaida;

            if (this.mensagens.filter(m => m.mensagemEntrada === mensagem.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi, '')).length > 0)
                return this.mensagens.filter(m => m.mensagemEntrada === mensagem.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi, ''))[0].mensagemSaida;

            if (this.mensagens.filter(m => m.mensagemEntrada === mensagem.replace('One or more errors occurred. (', '').replace(')', '')).length > 0)
                return this.mensagens.filter(m => m.mensagemEntrada === mensagem.replace('One or more errors occurred. (', '').replace(')', ''))[0].mensagemSaida;

            return mensagem?.replace('One or more errors occurred. (', '').replace(')', '');
        }
        catch{
            return mensagem;
        }
    }
}